import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableRow,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import { useRecoilState, useRecoilValue } from "recoil";

import SelectMenuItem from "../Customer/Component/SelectMenuItem";
import { useUpdateCustomerMutation } from "../../../Service/customers";
import { useDispatch, useSelector } from "react-redux";
import { GetcustomerList } from "../../../store/async-actions/digitalmarketing/dashboard";
import { useGetDashboardCustomersQuery } from "../../../Service/dashboard";
import { ServiceChosen } from "../Customer/Utils/CustomerLabelInput";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import PermissionCheck from "../../../Component/PermissionCheck";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import {
  useDeleteMedicineMasterMutation,
  useUpdateMedicineMasterMutation,
} from "../../../Service/MedicineMaster";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import { medicineUpdateSelector } from "../../../State/selectors";
import IosSwitchBtn from "../../../Component/DigitalMarketing/IosSwitchbtn";
import { formatWord } from "../../../utils";
const useStyles = makeStyles({
  Mimo: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FB6A6A",
      backgroundColor: "#FFF7F7",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Fertility: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3BB54A",
      backgroundColor: "#F7FFF8",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Action: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  status: {
    width: 148,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
});
interface props {
  customer_list: any;
  getComparator: any;
  order: any;
  orderBy: string;
  handleClick: any;
  handleChange: any;
  stableSort: any;
  state: any;
  setstates: any;
  setMedicine: any;
  refetch: any;
  setUpdated: any;
  updated: any;
  medicines: any;
  deleted: any;
  setDeleted: any;
  pagination: any;
  openSnackBar: any;
}
function TableList({
  customer_list,
  getComparator,
  order,
  updated,
  orderBy,
  handleClick,
  handleChange,
  state,
  deleted,
  setDeleted,
  setstates,
  setMedicine,
  setUpdated,
  medicines,
  refetch,
  pagination,
  openSnackBar,
  stableSort,
}: props) {
  const classes = useStyles();
  const [deleteMedicine] = useDeleteMedicineMasterMutation();
  const [updateMedicine, { isLoading: updateLoading }] =
    useUpdateMedicineMasterMutation();
  const [ishover, sethover] = useState(null);
  const [checkedStates, setCheckedStates] = useState([]);

  const handleSwitchChange = (index: any, id: number) => (event) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = event?.target?.checked;
    setCheckedStates(newCheckedStates);

    updateMedicineStatus(id, event.target.checked);
  };

  const updateMedicineStatus = async (id, status) => {
    await updateMedicine({ id, activeStatus: status ? "1" : "0" });
    refetch();
  };

  const handleMouseEnter = (index) => {
    sethover(index);
  };

  const dispatch = useDispatch<any>();
  const [medicineUpdate, setMedicineUpdate] = useRecoilState(
    medicineUpdateSelector
  );
  // console.log("medi",medicineUpdate);

  const DashboardStatus = useSelector((state: any) => state.dashboard.status);
  let status = DashboardStatus.map((item) => ({
    label: item.name,
    value: item.id,
    icon: (
      <span
        style={{ backgroundColor: item.others }}
        className="blue me-2"
      ></span>
    ),
  }));
  // console.log(status);

  const {
    open: open1,
    message: message1,
    openDelete,
    deleteId,
  } = useDeleteBox();
  const Delete = async (bool) => {
    // console.log(bool);

    if (bool) {
      try {
        // console.log(bool);

        const payload = await deleteMedicine(deleteId).unwrap();
        // console.log(payload);

        openSnackBar("Deleted successfully");

        setDeleted(true);
      } catch (error: any) {
        // console.log(error?.data?.error);

        openSnackBar(error?.data?.error, "error");
      }
    }
    openDelete("Are you sure you want to delete this User?", false, null);
  };
  const handleMouseLeave = () => {
    sethover(null);
  };

  const getValueByLabel = (label) => {
    let val = status.find((item) => item.label == label);
    if (val) {
      return val.value;
    }
    return 1;
  };

  const formatDateAndTime = (dateString: string) => {
    const date = new Date(dateString);

    // Format date
    const optionsDate: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "long",
      year: "numeric",
    };
    const formattedDate = date.toLocaleDateString("en-US", optionsDate);

    // Format time
    const optionsTime: Intl.DateTimeFormatOptions = {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

    // Convert month name to uppercase
    const parts = formattedDate.split(" ");
    parts[1] = parts[1].slice(0, -1);

    // console.log(parts[1]);

    parts[0] = parts[0].toUpperCase();
    parts[0] = parts[0].slice(0, 3);

    // console.log(parts[0]);

    // console.log(`${parts[0]} ${parts[1]} ${parts[2]} ${formattedTime}`);

    // Return formatted date and time
    return (
      <>
        {parts[1]} {parts[0]} {parts[2]}
        <br />
        {formattedTime}
      </>
    );
  };

  // const inputDate = '30 January 2024, 5:57 pm';
  // const formattedDateTime = formatDateAndTime(inputDate);
  // console.log(formattedDateTime); // Output: "30 JANUARY 2024 5:57 PM"

  const getLabelByValue = (value) => {
    let val = status.find((item) => item.value == value);
    if (val) {
      return val.label;
    }
    return "Created";
  };

  const handleEdit = (medicine) => {
    // console.log(medicine);

    setMedicine(medicine);
    setUpdated(false);

    setstates(!state);
  };

  useEffect(() => {
    if (medicines) {
      setCheckedStates(
        medicines.map((medicine) => medicine?.activeStatus === 1)
      );
    }
  }, [medicines]);

  return (
    <>
      <AlertDialog open={open1} message={message1} deleteBranches={Delete} />

      {stableSort(medicines, getComparator(order, orderBy))?.map((a, i) => {
        return (
          <TableRow role="checkbox" tabIndex={-1} key={i + 1}>
            <TableCell align="left">{(pagination - 1) * 20 + i + 1}</TableCell>

            <TableCell align="left">{formatWord(a.medicineName)}</TableCell>
            <TableCell align="left">{a.medicineType}</TableCell>

            <TableCell align="left">{a.medicineDose}</TableCell>
            <TableCell align="left">{a.manufacturing}</TableCell>
            <TableCell align="left">{a.count}</TableCell>
            <TableCell align="left">
              {/* <p
                style={{
                  borderRadius: "20px",
                  marginBottom: "0",
                  color: a.activeStatus ? "#439F77" : "#EB3068",
                  textAlign: "center",
                  backgroundColor: a.activeStatus ? "#EFF8FF" : "#FFF2F6",
                  padding: "6px 10px",
                }}
              >
                <span
                  style={{
                    width: "5px",
                    height: "5px",
                    padding: "0 7px",
                    borderRadius: "50%",
                    backgroundColor: a.activeStatus ? "#439F77" : "#EB3068",
                  }}
                ></span>{" "}
                &nbsp;&nbsp;{a.activeStatus ? "Active" : "Inactive"}
              </p> */}
              <IosSwitchBtn
                onChange={handleSwitchChange(i, a.id)}
                checked={
                  checkedStates[i] !== undefined ? checkedStates[i] : false
                }
                label={checkedStates[i] ? "Active" : "Inactive"}
              />
            </TableCell>

            {/* <TableCell align="left">
              <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <SelectMenuItem 
                styles={"select"} 
                name="stat" 
                option={status} 
          
                value={getValueByLabel(a.customerStatus)} 
                onChange={(e) => handleSelectChange(e,a)} 
                />
               
              </FormControl>
            </TableCell> */}
            {/* <TableCell align="left">
              <span>{a.last_contacted}</span>
              <br></br>
              <small>{a.time}</small>
            </TableCell> */}
            <TableCell align="left">
                <img
                  src={edit}
                  alt="edit"
                  className="blue-c action-icon cursur"
                  onClick={() => {
                    handleEdit(a);
                    setMedicineUpdate(true);
                  }}
                />
              &nbsp;&nbsp;&nbsp;
                <img
                  src={dele}
                  alt="delete"
                  onClick={() =>
                    openDelete(
                      "Are you sure you want to delete this medicine?",
                      true,
                      a.id
                    )
                  }
                  className="delete-icon cursur action-icon"
                />
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
